// extracted by mini-css-extract-plugin
module.exports = {"image":"CircleImage_image__1yKsj","notAllowed":"CircleImage_notAllowed__3a-AL"};